import { render, staticRenderFns } from "./CampanhaStatusBadge.vue?vue&type=template&id=6334cd70&scoped=true"
import script from "./CampanhaStatusBadge.vue?vue&type=script&lang=js"
export * from "./CampanhaStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./CampanhaStatusBadge.vue?vue&type=style&index=0&id=6334cd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334cd70",
  null
  
)

export default component.exports